module.exports = __webpack_public_path__ + "img/default-avatar.bdd9aaee.png";